import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import * as token from "@universityofmaryland/web-token-library";
import * as typography from "@universityofmaryland/web-styles-library/typography";
import * as layout from "@universityofmaryland/web-styles-library/layout";
import { theme } from "@universityofmaryland/web-utilities-library/theme";
import "@universityofmaryland/web-styles-library/element";
import "@universityofmaryland/web-styles-library/animation";
import "@universityofmaryland/web-utilities-library/media";
import "@universityofmaryland/web-utilities-library/dom";
import "@universityofmaryland/web-icons-library/controls";
import "@universityofmaryland/web-icons-library/communication";
import "@universityofmaryland/web-icons-library/files";
import "@universityofmaryland/web-icons-library/brand";
import "@universityofmaryland/web-icons-library/arrows";
import "@universityofmaryland/web-utilities-library/performance";
import { createAnimationChevronDrift } from "../../atomic/animations/brand/chevron-drift.js";
import "@universityofmaryland/web-utilities-library/styles";
import "../../atomic/animations/brand/card-stack.js";
import "@universityofmaryland/web-styles-library";
import "@universityofmaryland/web-utilities-library/accessibility";
import "@universityofmaryland/web-icons-library/location";
import "@universityofmaryland/web-icons-library/calendar";
import "../../atomic/layout/block/stacked.js";
import "../../atomic/layout/person/columns.js";
import "@universityofmaryland/web-icons-library/social";
import "@universityofmaryland/web-utilities-library/string";
import "@universityofmaryland/web-utilities-library/animation";
import { createTextLockupMedium } from "../../atomic/text-lockup/medium.js";
import "../../atomic/text-lockup/small.js";
const CONTENT_OVERLAY_CLASS = "brand-chevron-promo-content-overlay";
const ANIMATION_CONFIG = {
  FADE_UP: {
    DURATION: "1000ms",
    EASING: "ease-in-out",
    TRANSFORM: {
      FROM: "translateY(25px)",
      TO: "translateY(0)"
    }
  }
};
const MIN_HEIGHT = {
  MOBILE: "355px",
  DESKTOP: "500px"
};
const createHeadline = (headline) => {
  if (!headline) return null;
  return new ElementBuilder(headline).styled(
    typography.campaign.compose("large", {
      theme: theme.fontColor(true)
    })
  ).withStyles({
    element: {
      textTransform: "uppercase",
      textWrap: "balance"
    },
    siblingAfter: {
      marginTop: token.spacing.sm
    }
  }).build();
};
const createContent = (props) => {
  const { headline, eyebrow, text, actions } = props;
  const lockup = createTextLockupMedium({
    ribbon: eyebrow,
    compositeHeadline: createHeadline(headline),
    text,
    actions,
    isThemeDark: true
  });
  const container = new ElementBuilder().withClassName("brand-chevron-promo-content").withChild(lockup).withStyles({
    element: {
      position: "relative",
      textAlign: "center",
      width: `calc(100% - 24px)`,
      maxWidth: "950px",
      padding: `${token.spacing.xl} ${token.spacing.md}`,
      [`& .${layout.grid.stacked.className}`]: {
        justifyContent: "center",
        justifyItems: "center"
      }
    },
    pseudoBefore: {
      content: '""',
      position: "absolute",
      top: "-15%",
      left: "-25%",
      width: "150%",
      height: "130%",
      background: "radial-gradient(ellipse 50% 50% at center, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0.75) 55%, rgba(0, 0, 0, 0) 100%)",
      zIndex: -1,
      pointerEvents: "none"
    }
  }).build();
  return new ElementBuilder().withClassName(CONTENT_OVERLAY_CLASS).withChild(container).withStyles({
    element: {
      position: "relative",
      height: "100%",
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 98,
      opacity: 0,
      transform: ANIMATION_CONFIG.FADE_UP.TRANSFORM.FROM,
      transition: `opacity ${ANIMATION_CONFIG.FADE_UP.DURATION} ${ANIMATION_CONFIG.FADE_UP.EASING}, transform ${ANIMATION_CONFIG.FADE_UP.DURATION} ${ANIMATION_CONFIG.FADE_UP.EASING}`,
      ["@media (prefers-reduced-motion: reduce)"]: {
        opacity: "1 !important",
        transform: "none !important",
        transition: "none"
      }
    }
  }).build();
};
const createAnimationSequence = (container) => {
  return () => {
    const overlay = container.querySelector(
      `.${CONTENT_OVERLAY_CLASS}`
    );
    if (overlay) {
      overlay.style.opacity = "1";
      overlay.style.transform = ANIMATION_CONFIG.FADE_UP.TRANSFORM.TO;
    }
  };
};
const createCompositeBrandChevronPromo = (props) => {
  const { isAnimationOnLoad } = props;
  const composite = new ElementBuilder("section").withClassName("umd-element-brand-chevron-promo").withStyles({
    element: {
      position: "relative",
      width: "100%",
      minHeight: MIN_HEIGHT.MOBILE,
      backgroundColor: token.color.black,
      containerType: "inline-size",
      [`@media (${token.media.queries.tablet.min})`]: {
        minHeight: MIN_HEIGHT.DESKTOP
      }
    }
  }).build();
  const wrapper = new ElementBuilder().withClassName("brand-chevron-promo-wrapper").withChild(createContent(props)).withStyles({
    element: {
      position: "relative",
      overflow: "hidden",
      height: "100%",
      width: "100%",
      minHeight: "inherit",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  }).build();
  const overlay = createAnimationChevronDrift({
    sizedContainer: composite.element,
    completedCallback: createAnimationSequence(composite.element),
    isAnimationOnLoad
  });
  wrapper.element.appendChild(overlay.element);
  wrapper.styles += overlay.styles;
  composite.element.appendChild(wrapper.element);
  composite.styles += wrapper.styles;
  const events = {
    load: () => {
      overlay.events?.load();
    }
  };
  return {
    ...composite,
    events,
    destroy: overlay.destroy
  };
};
export {
  createCompositeBrandChevronPromo
};
//# sourceMappingURL=chevron-promo.js.map
